import React from 'react';
import { Link } from 'react-router-dom';

const FooterHU = () => {
  return (
    <footer className='footer'>
      <div className='copyright'>Copyright © 2019</div>
      <nav className='footer-menu'>
        <ul>
          <li>
            <Link to='/adatvedelmi-nyilatkozat'>Adatvédelmi nyilatkozat</Link>
          </li>
        </ul>
      </nav>
    </footer>
  );
};

export default FooterHU;
